import BoldSmallText from '@/components/BoldSmallText';
import BoldText from '@/components/BoldText';
import InformationBanner from '@/components/InformationBanner';
import { WIDGET_DISPLAY_CHOICE } from '@/constants/enum';
import { openCrisp } from '@/helpers';
import { widgetSettingSelector } from '@/redux/slice/widget.slice';
import { BlockStack, Card, InlineStack, Link } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { WidgetCartPageCard } from './WidgetCartPage';
import { WidgetProductPageCard } from './WidgetProductPage';
import { handleVisibleBanner, isOpenWidgetManuallyInforBannerSelector } from '@/redux/slice/banner.slice';
import RegularText from '@/components/RegularText';

export const WidgetPlaceManually = () => {
  const { t } = useTranslation('widget_settings');
  const widgetSettings = useSelector(widgetSettingSelector);
  const isOpenWidgetManuallyInforBanner = useSelector(isOpenWidgetManuallyInforBannerSelector);
  const dispatch = useDispatch();

  return (
    <Card padding={'300'}>
      <BlockStack gap={'300'}>
        <BoldText>{t('position.selector.title')}</BoldText>
        <InformationBanner
          isVisible={isOpenWidgetManuallyInforBanner}
          onDismiss={() =>
            dispatch(
              handleVisibleBanner({
                key: 'isOpenWidgetManuallyInforBanner',
                value: false,
              }),
            )
          }
        >
          If you have <BoldSmallText as="span">customized your default Shopify theme</BoldSmallText>, please specify where you
          want the date picker to appear by entering the selector of the target element.
        </InformationBanner>
        {widgetSettings.widgetPosition.displayOnPage.includes(WIDGET_DISPLAY_CHOICE.CART) && <WidgetCartPageCard />}
        {widgetSettings.widgetPosition.displayOnPage.includes(WIDGET_DISPLAY_CHOICE.PRODUCT) && <WidgetProductPageCard />}
        <InlineStack gap={'100'} blockAlign="center">
          <Link removeUnderline onClick={openCrisp}>
            {t('position.selector.instruction')}
          </Link>
          <RegularText> or </RegularText>
          <Link
            removeUnderline
            url="https://help.omegatheme.com/en/article/ensuring-app-compatibility-with-your-theme-ci7r7o/"
            target="_blank"
            external
          >
            {t('position.selector.readGuide')}
          </Link>
        </InlineStack>
      </BlockStack>
    </Card>
  );
};
